import { IsOneOfThese, IsValidDate } from '@core/services/csv/CSVCustomValidator'
import { CSVModelInterface } from '@core/services/csv/CSVModel.interface'
import { DateService } from '@master/services/DateService'
import { Expose } from 'class-transformer'
import { NBRImportDTOV2 } from '../api'
import { CitizenshipOptions } from '@master/model/options/CitizenshipOptions'
import { IdentityTypeOptions } from '@master/model/options/IdentityTypeOptions'
import { NationalityLabelToCode } from '@master/model/options/NationalityAndCountryOptions'
import { GenderOptions } from '@master/model/options/GenderOptions'
import { MaritalStatusOptions } from '@master/model/options/MaritalStatusOptions'
import { IncomeTierOptions, EduLevelOptions, EmploymentStatOptions } from '@master/model/client-management/ClientPersonal'
import { NBRStatusOptions } from '@master/model/options/NBRStatusOptions'
import { VenueOptions } from '@master/model/options/VenueOptions'
import { IsOptional, ValidateIf } from 'class-validator'
import { NBRProductStatusOptions } from '@master/model/options/NBRProductStatusOptions'
import { ClientPolicyV2 } from '../components/policy/model/ClientPolicyDTOV2'
import { PaymentMethodOptions } from '@master/model/options/PaymentMethodOptions'
import { PaymentModeOptions } from '@master/model/options/PaymentModeOptions'
import PolicyIndividualImport, { ClientSnapshotDataImport, PersonalInfoImport } from '../components/policy/model/PolicyIndividualImportDTO'
import { AdviserImport } from '../components/policy/model/AdviserImportDTO'
import { isEmpty } from 'lodash'

const dateService = new DateService()

export class NbrCsvImportModelV2 extends CSVModelInterface implements NBRImportDTOV2 {
  filename = 'NBRCSVTemplate'

  @Expose()
  private 'Issuer: Policy / Reference / Sub Policy Number' = '123456789'

  get policyNumber () {
    return this['Issuer: Policy / Reference / Sub Policy Number']
  }

  @Expose()
  @IsValidDate('DD/MM/YYYY')
  private 'Issuer: Application Date' = '12/12/2020'

  @Expose()
  @IsValidDate('DD/MM/YYYY')
  private 'Issuer: Approved Date' = '31/12/2020'

  @Expose()
  private 'Product: Issuer' = 'AIA'

  @Expose()
  private 'Product: Product Code' = '44'

  @Expose()
  private 'Product: Plan Name' = 'Plan01'

  @Expose()
  private 'Product: Frequency' = 'Monthly'

  @Expose()
  @IsOneOfThese(NBRProductStatusOptions.map(op => op.label))
  private 'Product: Policy Status' = 'In-force'

  @Expose()
  @IsValidDate('DD/MM/YYYY')
  private 'Product: Start Date' = '31/12/2020'

  @Expose()
  @IsValidDate('DD/MM/YYYY')
  private 'Product: End Date' = '31/12/2020'

  @Expose()
  @IsOneOfThese(PaymentModeOptions.map(op => op.label))
  private 'Product: Payment Mode' = 'Cash'

  // TO BE DEFINED AGAIN
  @Expose()
  private 'Product: Source Of Fund' = 'Cash'

  @Expose()
  private 'Product: Asp' = 12345

  @Expose()
  private 'Product: Currency' = 'SGD'

  @Expose()
  private 'Product: Onshore Offshore' = 'Onshore'

  @Expose()
  private 'NBR: Main Policy Number' = ''

  @Expose()
  @IsOneOfThese(VenueOptions.map(op => op.label))
  private 'NBR: Face To Face Application' = undefined

  @Expose()
  @IsValidDate('DD/MM/YYYY')
  private 'NBR: Approval Date' = '31/12/2020'

  @Expose()
  @IsOneOfThese(NBRStatusOptions.map(op => op.label))
  private 'NBR: Application Status' = 'Approved by Ops'

  @Expose()
  private 'NBR: Overseas Bank Account' = '100-001'

  @Expose()
  private 'NBR: Init Payment Method' = 'Cash'

  @Expose()
  private 'NBR: Remarks' = 'remarks'

  // Main Owner
  @Expose()
  private 'Main Owner: Client Id' = 'CMP_001'

  @Expose()
  private 'Main Owner: Title' = 'MR'

  @Expose()
  private 'Main Owner: Name' = 'John Doe'

  @Expose()
  private 'Main Owner: Nric' = 'S1234567A'

  @Expose()
  @IsOneOfThese(IdentityTypeOptions.map(op => op.label))
  private 'Main Owner: Id Type' = 'NRIC'

  @Expose()
  @IsOneOfThese(CitizenshipOptions.map(op => op.label))
  private 'Main Owner: Citizenship' = 'Singaporean'

  @Expose()
  private 'Main Owner: Nationality Others' = ''

  @Expose()
  private 'Main Owner: Nationality Others2' = ''

  @Expose()
  @IsOneOfThese(GenderOptions.map(op => op.label))
  private 'Main Owner: Gender' = 'Male'

  @Expose()
  @IsOneOfThese(MaritalStatusOptions.map(op => op.label))
  private 'Main Owner: Marital Status' = 'Single'

  @Expose()
  @IsValidDate('DD/MM/YYYY')
  private 'Main Owner: Dob' = '31/12/1950'

  @Expose()
  @IsValidDate('DD/MM/YYYY')
  private 'Main Owner: Date Of Incorporation' = '31/12/2020'

  @Expose()
  private 'Main Owner: Residential Address One' = 'Woodlands Ave 1'

  @Expose()
  private 'Main Owner: Country Of Residence One' = 'Singapore'

  @Expose()
  private 'Main Owner: Postal Code One' = '987654'

  @Expose()
  private 'Main Owner: Home No One' = '69876543'

  @Expose()
  private 'Main Owner: Office No One' = ''

  @Expose()
  private 'Main Owner: Mobile No One' = '98765432'

  @Expose()
  private 'Main Owner: Email One' = 'email1@email.com'

  @Expose()
  private 'Main Owner: Occupation' = 'IT'

  @Expose()
  @IsOneOfThese(EmploymentStatOptions.map(op => op.label))
  private 'Main Owner: Employment Status' = 'Full Time'

  @Expose()
  private 'Main Owner: Company Name' = 'ABC'

  @Expose()
  @IsOneOfThese(IncomeTierOptions.map(op => op.label))
  private 'Main Owner: Annual Income Range' = ''

  @Expose()
  @IsOneOfThese(EduLevelOptions.map(op => op.label))
  private 'Main Owner: Edu Lvl' = ''

  @Expose()
  private 'Main Owner: Is Accredited Investor' = false

  @Expose()
  private 'Main Owner: Is Overseas Investor' = false

  @Expose()
  private 'Main Owner: Passed Cka' = true

  get mainOwner () {
    const mainOwner = new PolicyIndividualImport()
    const clientSnapshotData = new ClientSnapshotDataImport()
    clientSnapshotData.clientId = this['Main Owner: Client Id']
    clientSnapshotData.title = this['Main Owner: Title']?.toLowerCase() || ''
    clientSnapshotData.nric = this['Main Owner: Nric']
    clientSnapshotData.name = this['Main Owner: Name']
    const personalInfoJson = new PersonalInfoImport()
    personalInfoJson.gender = GenderOptions.find(op => op.label.toUpperCase() === this['Main Owner: Gender']?.toUpperCase())?.value || ''
    personalInfoJson.identityType = IdentityTypeOptions.find(op => op.label === this['Main Owner: Id Type'])?.value?.toString() || ''
    personalInfoJson.citizenship = CitizenshipOptions.find(op => op.label === this['Main Owner: Citizenship'])?.value || ''
    personalInfoJson.nationalityOthers = NationalityLabelToCode[this['Main Owner: Nationality Others']?.toUpperCase()] || ''
    personalInfoJson.nationalityOthers2 = NationalityLabelToCode[this['Main Owner: Nationality Others2']?.toUpperCase()] || ''
    personalInfoJson.maritalStatus = MaritalStatusOptions.find(op => op.label.toUpperCase() === this['Main Owner: Marital Status']?.toUpperCase())?.value || ''
    personalInfoJson.dob = dateService.toUnixMilliseconds(this['Main Owner: Dob'], 'DD/MM/YYYY')
    personalInfoJson.registrationDate = dateService.toUnixMilliseconds(this['Main Owner: Date Of Incorporation'], 'DD/MM/YYYY')
    personalInfoJson.residentialAddressOne = this['Main Owner: Residential Address One']
    personalInfoJson.postalCodeOne = this['Main Owner: Postal Code One']
    personalInfoJson.countryOfResidenceOne = this['Main Owner: Country Of Residence One']
    personalInfoJson.homeNoOne = this['Main Owner: Home No One']
    personalInfoJson.mobileNoOne = this['Main Owner: Mobile No One']
    personalInfoJson.officeNoOne = this['Main Owner: Office No One']
    personalInfoJson.emailOne = this['Main Owner: Email One']
    personalInfoJson.companyName = this['Main Owner: Company Name']
    personalInfoJson.occupation = this['Main Owner: Occupation']
    personalInfoJson.employmentStatus = EmploymentStatOptions.find(op => op.label === this['Main Owner: Employment Status'])?.value || ''
    personalInfoJson.annualIncomeRange = IncomeTierOptions.find(op => op.label === this['Main Owner: Annual Income Range'])?.value || ''
    personalInfoJson.highestEducationLevel = EduLevelOptions.find(op => op.label === this['Main Owner: Edu Lvl'])?.value || ''
    personalInfoJson.isAccreditedInvestor = this['Main Owner: Is Accredited Investor']
    personalInfoJson.isOverseasInvestor = this['Main Owner: Is Overseas Investor']
    personalInfoJson.ckaPassed = this['Main Owner: Passed Cka']
    clientSnapshotData.personalInfoJson = personalInfoJson
    mainOwner.clientDataSnapshot = clientSnapshotData
    return mainOwner
  }

  // Joint Owner
  @Expose()
  @IsOptional()
  private 'Joint Owner: Nric' = 'S1234567A'

  @Expose()
  @IsOptional()
  private 'Joint Owner: Name' = ''

  @Expose()
  @ValidateIf((object, value) => !isEmpty(value))
  @IsOneOfThese(IdentityTypeOptions.map(op => op.label))
  private 'Joint Owner: Id Type' = 'NRIC'

  @Expose()
  @IsOptional()
  @IsValidDate('DD/MM/YYYY')
  private 'Joint Owner: Dob' = ''

  @Expose()
  @IsOptional()
  private 'Joint Owner: Gender' = ''

  @Expose()
  @IsOptional()
  private 'Joint Owner: Marital Status' = ''

  @Expose()
  @IsOptional()
  private 'Joint Owner: Citizenship' = ''

  @Expose()
  @IsOptional()
  private 'Joint Owner: Residential Address One' = ''

  @Expose()
  @IsOptional()
  private 'Joint Owner: Country Of Residence One' = ''

  @Expose()
  @IsOptional()
  private 'Joint Owner: Postal Code One' = ''

  @Expose()
  @IsOptional()
  private 'Joint Owner: Home No One' = ''

  @Expose()
  @IsOptional()
  private 'Joint Owner: Office No One' = ''

  @Expose()
  @IsOptional()
  private 'Joint Owner: Mobile No One' = ''

  @Expose()
  @IsOptional()
  private 'Joint Owner: Email One' = ''

  get jointOwner () {
    const jointOwner = new PolicyIndividualImport()
    const clientSnapshotData = new ClientSnapshotDataImport()
    clientSnapshotData.clientId = this['Joint Owner: Client Id']
    clientSnapshotData.title = this['Joint Owner: Title']?.toLowerCase() || ''
    clientSnapshotData.nric = this['Joint Owner: Nric']
    clientSnapshotData.name = this['Joint Owner: Name']
    const personalInfoJson = new PersonalInfoImport()
    personalInfoJson.identityType = IdentityTypeOptions.find(op => op.label === this['Joint Owner: Id Type'])?.value?.toString() || ''
    personalInfoJson.gender = GenderOptions.find(op => op.label.toUpperCase() === this['Joint Owner: Gender']?.toUpperCase())?.value || ''
    personalInfoJson.citizenship = CitizenshipOptions.find(op => op.label === this['Joint Owner: Citizenship'])?.value || ''
    personalInfoJson.nationalityOthers = NationalityLabelToCode[this['Joint Owner: Nationality Others']?.toUpperCase()] || ''
    personalInfoJson.nationalityOthers2 = NationalityLabelToCode[this['Joint Owner: Nationality Others2']?.toUpperCase()] || ''
    personalInfoJson.maritalStatus = MaritalStatusOptions.find(op => op.label.toUpperCase() === this['Joint Owner: Marital Status']?.toUpperCase())?.value || ''
    personalInfoJson.dob = dateService.toUnixMilliseconds(this['Joint Owner: Dob'], 'DD/MM/YYYY')
    personalInfoJson.registrationDate = dateService.toUnixMilliseconds(this['Joint Owner: Date Of Incorporation'], 'DD/MM/YYYY')
    personalInfoJson.residentialAddressOne = this['Joint Owner: Residential Address One']
    personalInfoJson.postalCodeOne = this['Joint Owner: Postal Code One']
    personalInfoJson.countryOfResidenceOne = this['Joint Owner: Country Of Residence One']
    personalInfoJson.homeNoOne = this['Joint Owner: Home No One']
    personalInfoJson.mobileNoOne = this['Joint Owner: Mobile No One']
    personalInfoJson.officeNoOne = this['Joint Owner: Office No One']
    personalInfoJson.emailOne = this['Joint Owner: Email One']
    personalInfoJson.companyName = this['Joint Owner: Company Name']
    personalInfoJson.occupation = this['Joint Owner: Occupation']
    personalInfoJson.employmentStatus = EmploymentStatOptions.find(op => op.label === this['Joint Owner: Employment Status'])?.value || ''
    personalInfoJson.annualIncomeRange = IncomeTierOptions.find(op => op.label === this['Joint Owner: Annual Income Range'])?.value || ''
    personalInfoJson.highestEducationLevel = EduLevelOptions.find(op => op.label === this['Joint Owner: Edu Lvl'])?.value || ''
    personalInfoJson.isAccreditedInvestor = this['Joint Owner: Is Accredited Investor']
    personalInfoJson.isOverseasInvestor = this['Joint Owner: Is Overseas Investor']
    personalInfoJson.ckaPassed = this['Joint Owner: Passed Cka']
    clientSnapshotData.personalInfoJson = personalInfoJson
    jointOwner.clientDataSnapshot = clientSnapshotData
    return jointOwner
  }

  // Insured One

  @Expose()
  @IsOptional()
  private 'Insured One: Nric' = 'S1234567A'

  @Expose()
  @IsOptional()
  private 'Insured One: Name' = ''

  @Expose()
  @ValidateIf((object, value) => !isEmpty(value))
  @IsOneOfThese(IdentityTypeOptions.map(op => op.label))
  private 'Insured One: Id Type' = 'NRIC'

  @Expose()
  @IsOptional()
  @IsValidDate('DD/MM/YYYY')
  private 'Insured One: Dob' = ''

  @Expose()
  @IsOptional()
  private 'Insured One: Gender' = ''

  @Expose()
  @IsOptional()
  private 'Insured One: Marital Status' = ''

  @Expose()
  @IsOptional()
  private 'Insured One: Citizenship' = ''

  @Expose()
  @IsOptional()
  private 'Insured One: Residential Address One' = ''

  @Expose()
  @IsOptional()
  private 'Insured One: Country Of Residence One' = ''

  @Expose()
  @IsOptional()
  private 'Insured One: Postal Code One' = ''

  @Expose()
  @IsOptional()
  private 'Insured One: Home No One' = ''

  @Expose()
  @IsOptional()
  private 'Insured One: Office No One' = ''

  @Expose()
  @IsOptional()
  private 'Insured One: Mobile No One' = ''

  @Expose()
  @IsOptional()
  private 'Insured One: Email One' = ''

  get lifeAssuredOne () {
    const lifeAssured = new PolicyIndividualImport()
    const clientSnapshotData = new ClientSnapshotDataImport()
    clientSnapshotData.clientId = this['Insured One: Client Id']
    clientSnapshotData.title = this['Insured One: Title']?.toLowerCase() || ''
    clientSnapshotData.nric = this['Insured One: Nric']
    clientSnapshotData.name = this['Insured One: Name']
    const personalInfoJson = new PersonalInfoImport()
    personalInfoJson.identityType = IdentityTypeOptions.find(op => op.label === this['Insured One: Id Type'])?.value?.toString() || ''
    personalInfoJson.gender = GenderOptions.find(op => op.label.toUpperCase() === this['Insured One: Gender']?.toUpperCase())?.value || ''
    personalInfoJson.citizenship = CitizenshipOptions.find(op => op.label === this['Insured One: Citizenship'])?.value || ''
    personalInfoJson.nationalityOthers = NationalityLabelToCode[this['Insured One: Nationality Others']?.toUpperCase()] || ''
    personalInfoJson.nationalityOthers2 = NationalityLabelToCode[this['Insured One: Nationality Others2']?.toUpperCase()] || ''
    personalInfoJson.maritalStatus = MaritalStatusOptions.find(op => op.label.toUpperCase() === this['Insured One: Marital Status']?.toUpperCase())?.value || ''
    personalInfoJson.dob = dateService.toUnixMilliseconds(this['Insured One: Dob'], 'DD/MM/YYYY')
    personalInfoJson.registrationDate = dateService.toUnixMilliseconds(this['Insured One: Date Of Incorporation'], 'DD/MM/YYYY')
    personalInfoJson.residentialAddressOne = this['Insured One: Residential Address One']
    personalInfoJson.postalCodeOne = this['Insured One: Postal Code One']
    personalInfoJson.countryOfResidenceOne = this['Insured One: Country Of Residence One']
    personalInfoJson.homeNoOne = this['Insured One: Home No One']
    personalInfoJson.mobileNoOne = this['Insured One: Mobile No One']
    personalInfoJson.officeNoOne = this['Insured One: Office No One']
    personalInfoJson.emailOne = this['Insured One: Email One']
    personalInfoJson.companyName = this['Insured One: Company Name']
    personalInfoJson.occupation = this['Insured One: Occupation']
    personalInfoJson.employmentStatus = EmploymentStatOptions.find(op => op.label === this['Insured One: Employment Status'])?.value || ''
    personalInfoJson.annualIncomeRange = IncomeTierOptions.find(op => op.label === this['Insured One: Annual Income Range'])?.value || ''
    personalInfoJson.highestEducationLevel = EduLevelOptions.find(op => op.label === this['Insured One: Edu Lvl'])?.value || ''
    personalInfoJson.isAccreditedInvestor = this['Insured One: Is Accredited Investor']
    personalInfoJson.isOverseasInvestor = this['Insured One: Is Overseas Investor']
    personalInfoJson.ckaPassed = this['Insured One: Passed Cka']
    clientSnapshotData.personalInfoJson = personalInfoJson
    lifeAssured.clientDataSnapshot = clientSnapshotData
    return lifeAssured
  }

  // Life Asssured Two

  @Expose()
  @IsOptional()
  private 'Life Assured Two: Nric' = 'S1234567A'

  @Expose()
  @IsOptional()
  private 'Life Assured Two: Name' = ''

  @Expose()
  @ValidateIf((object, value) => !isEmpty(value))
  @IsOneOfThese(IdentityTypeOptions.map(op => op.label))
  private 'Life Assured Two: Id Type' = 'NRIC'

  @Expose()
  @IsOptional()
  @IsValidDate('DD/MM/YYYY')
  private 'Life Assured Two: Dob' = ''

  @Expose()
  @IsOptional()
  private 'Life Assured Two: Gender' = ''

  @Expose()
  @IsOptional()
  private 'Life Assured Two: Marital Status' = ''

  @Expose()
  @IsOptional()
  private 'Life Assured Two: Citizenship' = ''

  @Expose()
  @IsOptional()
  private 'Life Assured Two: Residential Address One' = ''

  @Expose()
  @IsOptional()
  private 'Life Assured Two: Country Of Residence One' = ''

  @Expose()
  @IsOptional()
  private 'Life Assured Two: Postal Code One' = ''

  @Expose()
  @IsOptional()
  private 'Life Assured Two: Home No One' = ''

  @Expose()
  @IsOptional()
  private 'Life Assured Two: Office No One' = ''

  @Expose()
  @IsOptional()
  private 'Life Assured Two: Mobile No One' = ''

  @Expose()
  @IsOptional()
  private 'Life Assured Two: Email One' = ''

  get lifeAssuredTwo () {
    const lifeAssured = new PolicyIndividualImport()
    const clientSnapshotData = new ClientSnapshotDataImport()
    clientSnapshotData.clientId = this['Life Assured Two: Client Id']
    clientSnapshotData.title = this['Life Assured Two: Title']?.toLowerCase() || ''
    clientSnapshotData.nric = this['Life Assured Two: Nric']
    clientSnapshotData.name = this['Life Assured Two: Name']
    const personalInfoJson = new PersonalInfoImport()
    personalInfoJson.identityType = IdentityTypeOptions.find(op => op.label.toUpperCase() === this['Life Assured Two: Id Type']?.toUpperCase())?.value?.toString() || ''
    personalInfoJson.gender = GenderOptions.find(op => op.label.toUpperCase() === this['Life Assured Two: Gender']?.toUpperCase())?.value || ''
    personalInfoJson.citizenship = CitizenshipOptions.find(op => op.label === this['Life Assured Two: Citizenship'])?.value || ''
    personalInfoJson.nationalityOthers = NationalityLabelToCode[this['Life Assured Two: Nationality Others']?.toUpperCase()] || ''
    personalInfoJson.nationalityOthers2 = NationalityLabelToCode[this['Life Assured Two: Nationality Others2']?.toUpperCase()] || ''
    personalInfoJson.maritalStatus = MaritalStatusOptions.find(op => op.label.toUpperCase() === this['Life Assured Two: Marital Status']?.toUpperCase())?.value || ''
    personalInfoJson.dob = dateService.toUnixMilliseconds(this['Life Assured Two: Dob'], 'DD/MM/YYYY')
    personalInfoJson.registrationDate = dateService.toUnixMilliseconds(this['Life Assured Two: Date Of Incorporation'], 'DD/MM/YYYY')
    personalInfoJson.residentialAddressOne = this['Life Assured Two: Residential Address One']
    personalInfoJson.postalCodeOne = this['Life Assured Two: Postal Code One']
    personalInfoJson.countryOfResidenceOne = this['Life Assured Two: Country Of Residence One']
    personalInfoJson.homeNoOne = this['Life Assured Two: Home No One']
    personalInfoJson.mobileNoOne = this['Life Assured Two: Mobile No One']
    personalInfoJson.officeNoOne = this['Life Assured Two: Office No One']
    personalInfoJson.emailOne = this['Life Assured Two: Email One']
    personalInfoJson.companyName = this['Life Assured Two: Company Name']
    personalInfoJson.occupation = this['Life Assured Two: Occupation']
    personalInfoJson.employmentStatus = EmploymentStatOptions.find(op => op.label.toUpperCase() === this['Life Assured Two: Employment Status']?.toUpperCase())?.value || ''
    personalInfoJson.annualIncomeRange = IncomeTierOptions.find(op => op.label.toUpperCase() === this['Life Assured Two: Annual Income Range']?.toUpperCase())?.value || ''
    personalInfoJson.highestEducationLevel = EduLevelOptions.find(op => op.label.toUpperCase() === this['Life Assured Two: Edu Lvl']?.toUpperCase())?.value || ''
    personalInfoJson.isAccreditedInvestor = this['Life Assured Two: Is Accredited Investor']
    personalInfoJson.isOverseasInvestor = this['Life Assured Two: Is Overseas Investor']
    personalInfoJson.ckaPassed = this['Life Assured Two: Passed Cka']
    clientSnapshotData.personalInfoJson = personalInfoJson
    lifeAssured.clientDataSnapshot = clientSnapshotData
    return lifeAssured
  }

  // Third Party Payor

  @Expose()
  @IsOptional()
  private 'Third Party Payor: Nric' = 'S1234567A'

  @Expose()
  @IsOptional()
  private 'Third Party Payor: Name' = ''

  @Expose()
  @ValidateIf((object, value) => !isEmpty(value))
  @IsOneOfThese(IdentityTypeOptions.map(op => op.label))
  private 'Third Party Payor: Id Type' = 'NRIC'

  @Expose()
  @IsOptional()
  @IsValidDate('DD/MM/YYYY')
  private 'Third Party Payor: Dob' = ''

  @Expose()
  @IsOptional()
  private 'Third Party Payor: Gender' = ''

  @Expose()
  @IsOptional()
  private 'Third Party Payor: Marital Status' = ''

  @Expose()
  @IsOptional()
  private 'Third Party Payor: Citizenship' = ''

  @Expose()
  @IsOptional()
  private 'Third Party Payor: Residential Address One' = ''

  @Expose()
  @IsOptional()
  private 'Third Party Payor: Country Of Residence One' = ''

  @Expose()
  @IsOptional()
  private 'Third Party Payor: Postal Code One' = ''

  @Expose()
  @IsOptional()
  private 'Third Party Payor: Home No One' = ''

  @Expose()
  @IsOptional()
  private 'Third Party Payor: Office No One' = ''

  @Expose()
  @IsOptional()
  private 'Third Party Payor: Mobile No One' = ''

  @Expose()
  @IsOptional()
  private 'Third Party Payor: Email One' = ''

  get thirdPartyPayor () {
    const lifeAssured = new PolicyIndividualImport()
    const clientSnapshotData = new ClientSnapshotDataImport()
    clientSnapshotData.clientId = this['Third Party Payor: Client Id']
    clientSnapshotData.title = this['Third Party Payor: Title']?.toLowerCase() || ''
    clientSnapshotData.nric = this['Third Party Payor: Nric']
    clientSnapshotData.name = this['Third Party Payor: Name']
    const personalInfoJson = new PersonalInfoImport()
    personalInfoJson.identityType = IdentityTypeOptions.find(op => op.label.toUpperCase() === this['Third Party Payor: Id Type']?.toUpperCase())?.value?.toString() || ''
    personalInfoJson.gender = GenderOptions.find(op => op.label.toUpperCase() === this['Third Party Payor: Gender']?.toUpperCase())?.value || ''
    personalInfoJson.citizenship = CitizenshipOptions.find(op => op.label.toUpperCase() === this['Third Party Payor: Citizenship']?.toUpperCase())?.value || ''
    personalInfoJson.nationalityOthers = NationalityLabelToCode[this['Third Party Payor: Nationality Others']?.toUpperCase()] || ''
    personalInfoJson.nationalityOthers2 = NationalityLabelToCode[this['Third Party Payor: Nationality Others2']?.toUpperCase()] || ''
    personalInfoJson.maritalStatus = MaritalStatusOptions.find(op => op.label.toUpperCase() === this['Third Party Payor: Marital Status']?.toUpperCase())?.value || ''
    personalInfoJson.dob = dateService.toUnixMilliseconds(this['Third Party Payor: Dob'], 'DD/MM/YYYY')
    personalInfoJson.registrationDate = dateService.toUnixMilliseconds(this['Third Party Payor: Date Of Incorporation'], 'DD/MM/YYYY')
    personalInfoJson.residentialAddressOne = this['Third Party Payor: Residential Address One']
    personalInfoJson.postalCodeOne = this['Third Party Payor: Postal Code One']
    personalInfoJson.countryOfResidenceOne = this['Third Party Payor: Country Of Residence One']
    personalInfoJson.homeNoOne = this['Third Party Payor: Home No One']
    personalInfoJson.mobileNoOne = this['Third Party Payor: Mobile No One']
    personalInfoJson.officeNoOne = this['Third Party Payor: Office No One']
    personalInfoJson.emailOne = this['Third Party Payor: Email One']
    personalInfoJson.companyName = this['Third Party Payor: Company Name']
    personalInfoJson.occupation = this['Third Party Payor: Occupation']
    personalInfoJson.employmentStatus = EmploymentStatOptions.find(op => op.label.toUpperCase() === this['Third Party Payor: Employment Status']?.toUpperCase())?.value || ''
    personalInfoJson.annualIncomeRange = IncomeTierOptions.find(op => op.label.toUpperCase() === this['Third Party Payor: Annual Income Range']?.toUpperCase())?.value || ''
    personalInfoJson.highestEducationLevel = EduLevelOptions.find(op => op.label.toUpperCase() === this['Third Party Payor: Edu Lvl']?.toUpperCase())?.value || ''
    personalInfoJson.isAccreditedInvestor = this['Third Party Payor: Is Accredited Investor']
    personalInfoJson.isOverseasInvestor = this['Third Party Payor: Is Overseas Investor']
    personalInfoJson.ckaPassed = this['Third Party Payor: Passed Cka']
    clientSnapshotData.personalInfoJson = personalInfoJson
    lifeAssured.clientDataSnapshot = clientSnapshotData
    return lifeAssured
  }

  // Beneficial Owner

  @Expose()
  @IsOptional()
  private 'Beneficial Owner: Nric' = 'S1234567A'

  @Expose()
  @IsOptional()
  private 'Beneficial Owner: Name' = ''

  @Expose()
  @ValidateIf((object, value) => !isEmpty(value))
  @IsOneOfThese(IdentityTypeOptions.map(op => op.label))
  private 'Beneficial Owner: Id Type' = 'NRIC'

  @Expose()
  @IsOptional()
  @IsValidDate('DD/MM/YYYY')
  private 'Beneficial Owner: Dob' = ''

  @Expose()
  @IsOptional()
  private 'Beneficial Owner: Gender' = ''

  @Expose()
  @IsOptional()
  private 'Beneficial Owner: Marital Status' = ''

  @Expose()
  @IsOptional()
  private 'Beneficial Owner: Citizenship' = ''

  @Expose()
  @IsOptional()
  private 'Beneficial Owner: Residential Address One' = ''

  @Expose()
  private 'Beneficial Owner: Country Of Residence One' = ''

  @Expose()
  @IsOptional()
  private 'Beneficial Owner: Postal Code One' = ''

  @Expose()
  @IsOptional()
  private 'Beneficial Owner: Home No One' = ''

  @Expose()
  @IsOptional()
  private 'Beneficial Owner: Office No One' = ''

  @Expose()
  @IsOptional()
  private 'Beneficial Owner: Mobile No One' = ''

  @Expose()
  @IsOptional()
  private 'Beneficial Owner: Email One' = ''

  get beneficialOwner () {
    const lifeAssured = new PolicyIndividualImport()
    const clientSnapshotData = new ClientSnapshotDataImport()
    clientSnapshotData.clientId = this['Beneficial Owner: Client Id']
    clientSnapshotData.title = this['Beneficial Owner: Title']?.toLowerCase() || ''
    clientSnapshotData.nric = this['Beneficial Owner: Nric']
    clientSnapshotData.name = this['Beneficial Owner: Name']
    const personalInfoJson = new PersonalInfoImport()
    personalInfoJson.identityType = IdentityTypeOptions.find(op => op.label.toUpperCase() === this['Beneficial Owner: Id Type'].toUpperCase())?.value?.toString() || ''
    personalInfoJson.gender = GenderOptions.find(op => op.label.toUpperCase() === this['Beneficial Owner: Gender']?.toUpperCase())?.value || ''
    personalInfoJson.citizenship = CitizenshipOptions.find(op => op.label.toLowerCase() === this['Beneficial Owner: Citizenship']?.toLowerCase())?.value || ''
    personalInfoJson.nationalityOthers = NationalityLabelToCode[this['Beneficial Owner: Nationality Others']?.toUpperCase()] || ''
    personalInfoJson.nationalityOthers2 = NationalityLabelToCode[this['Beneficial Owner: Nationality Others2']?.toUpperCase()] || ''
    personalInfoJson.maritalStatus = MaritalStatusOptions.find(op => op.label.toUpperCase() === this['Beneficial Owner: Marital Status']?.toUpperCase())?.value || ''
    personalInfoJson.dob = dateService.toUnixMilliseconds(this['Beneficial Owner: Dob'], 'DD/MM/YYYY')
    personalInfoJson.registrationDate = dateService.toUnixMilliseconds(this['Beneficial Owner: Date Of Incorporation'], 'DD/MM/YYYY')
    personalInfoJson.residentialAddressOne = this['Beneficial Owner: Residential Address One']
    personalInfoJson.postalCodeOne = this['Beneficial Owner: Postal Code One']
    personalInfoJson.countryOfResidenceOne = this['Beneficial Owner: Country Of Residence One']
    personalInfoJson.homeNoOne = this['Beneficial Owner: Home No One']
    personalInfoJson.mobileNoOne = this['Beneficial Owner: Mobile No One']
    personalInfoJson.officeNoOne = this['Beneficial Owner: Office No One']
    personalInfoJson.emailOne = this['Beneficial Owner: Email One']
    personalInfoJson.companyName = this['Beneficial Owner: Company Name']
    personalInfoJson.occupation = this['Beneficial Owner: Occupation']
    personalInfoJson.employmentStatus = EmploymentStatOptions.find(op => op.label.toUpperCase() === this['Beneficial Owner: Employment Status']?.toUpperCase())?.value || ''
    personalInfoJson.annualIncomeRange = IncomeTierOptions.find(op => op.label.toUpperCase() === this['Beneficial Owner: Annual Income Range']?.toUpperCase())?.value || ''
    personalInfoJson.highestEducationLevel = EduLevelOptions.find(op => op.label.toUpperCase() === this['Beneficial Owner: Edu Lvl']?.toUpperCase())?.value || ''
    personalInfoJson.isAccreditedInvestor = this['Beneficial Owner: Is Accredited Investor']
    personalInfoJson.isOverseasInvestor = this['Beneficial Owner: Is Overseas Investor']
    personalInfoJson.ckaPassed = this['Beneficial Owner: Passed Cka']
    clientSnapshotData.personalInfoJson = personalInfoJson
    lifeAssured.clientDataSnapshot = clientSnapshotData
    return lifeAssured
  }

  // Adviser

  @Expose()
  private 'Adviser: Company Code' = 'PFP0001'

  @Expose()
  private 'Adviser: Fullname' = 'Adviser01'

  get adviser () {
    const adviser = new AdviserImport()
    adviser.companyCode = this['Adviser: Company Code']
    adviser.fullname = this['Adviser: Fullname']
    return adviser
  }

  // Life Insurance Specific Columns

  @Expose()
  private 'Life Insurance: Basic Premium' = '1000'

  @Expose()
  private 'Life Insurance: Premium Term' = 'Term1'

  @Expose()
  private 'Life Insurance: Policy Term' = 'Term1'

  // Investment Specific Columns

  @Expose()
  private 'Investment: Transaction No' = 'T-001'

  @Expose()
  private 'Investment: Transaction Type' = 'Buy'

  @Expose()
  private 'Investment: Amount' = 12345

  @Expose()
  private 'Investment: Initial Charges' = '0'

  @Expose()
  private 'Investment: Switch Fees' = '100'

  get policy () {
    const clientPolicy = new ClientPolicyV2()
    clientPolicy.policyNumber = this.policyNumber
    clientPolicy.applicationDate = dateService.toUnixMilliseconds(this['Issuer: Application Date'], 'DD/MM/YYYY')
    clientPolicy.approvedDate = dateService.toUnixMilliseconds(this['Issuer: Approved Date'], 'DD/MM/YYYY')
    clientPolicy.status = NBRStatusOptions.find(op => op.label.toUpperCase() === this['NBR: Application Status']?.toUpperCase())?.value?.toString() || ''
    clientPolicy.opsApprovalDate = dateService.toUnixMilliseconds(this['NBR: Approval Date'], 'DD/MM/YYYY')
    clientPolicy.principal = this['Product: Issuer']
    clientPolicy.faceToFace = VenueOptions.find(op => op.label.toUpperCase() === this['NBR: Face To Face Application']?.toUpperCase())?.value
    clientPolicy.startDate = dateService.toUnixMilliseconds(this['Product: Start Date'], 'DD/MM/YYYY')
    clientPolicy.endDate = dateService.toUnixMilliseconds(this['Product: End Date'], 'DD/MM/YYYY')
    clientPolicy.productMetadata = {}
    clientPolicy.productMetadata.productCode = this['Product: Product Code']
    clientPolicy.productMetadata.name = this['Product: Plan Name']
    clientPolicy.productMetadata.frequency = this['Product: Frequency']
    clientPolicy.productMetadata.productStatus = NBRProductStatusOptions.find(op => op.label.toLowerCase() === this['Product: Policy Status']?.toLowerCase())?.value.toString() || ''
    clientPolicy.productMetadata.paymentMode = PaymentModeOptions.find(op => op.label.toLowerCase() === this['Product: Payment Mode']?.toLowerCase())?.value.toString() || ''
    clientPolicy.productMetadata.sourceOfFund = this['Product: Source Of Fund']
    clientPolicy.productMetadata.asp = this['Product: Asp']
    clientPolicy.productMetadata.currency = this['Product: Currency']
    clientPolicy.productMetadata.onshoreOffshore = this['Product: Onshore Offshore']
    clientPolicy.productMetadata.initPaymentMethod = this['NBR: Init Payment Method']
    clientPolicy.productMetadata.overseasBankAccount = this['NBR: Overseas Bank Account']
    clientPolicy.productMetadata.remarks = this['NBR: Remarks']
    clientPolicy.productMetadata.premiumAmount = this['Life Insurance: Basic Premium']
    clientPolicy.productMetadata.premiumTerm = this['Life Insurance: Premium Term']
    clientPolicy.productMetadata.policyTerm = this['Life Insurance: Policy Term']
    clientPolicy.productMetadata.transactionNo = this['Investment: Transaction No']
    clientPolicy.productMetadata.transactionType = this['Investment: Transaction Type']
    clientPolicy.productMetadata.investmentAmount = this['Investment: Amount']
    clientPolicy.productMetadata.initialCharges = this['Investment: Initial Charges']
    clientPolicy.productMetadata.switchFees = this['Investment: Switch Fees']
    return clientPolicy
  }

  get mainPolicyNumber () {
    return this['NBR: Main Policy Number']
  }
}
